<div class="topbar-spacer" *ngIf="landingPage$ | async as page">
  <app-header
    [skewBottom]="headerHasSkewBottom"
    [title]="page.header.title"
    [text]="page.header.intro"
    [imageUrl]="page.header.image.url"
    [buttons]="page.header.buttons"
  ></app-header>

  <ng-container>
    <!-- <pre>{{ page | json }}</pre> -->
    <app-content-block-container [blocks]="page.contentBlocks"></app-content-block-container>
  </ng-container>
  <!-- <pre>{{ landingPage$ | async | json }}</pre> -->
</div>
